import Alpine from 'alpinejs';

Alpine.store('review', {
    step: 'form',
    rating: 0,
    review: '',
    loading: false,
    error: '',
    reservationId: '',
    listingTitle: '',
    streetAddress: '',
    locationLabel: '',
    dateRange: '',
    imageUrl: '',

    open(reservationId, details = {}) {
        this.step = 'form';
        this.rating = 0;
        this.review = '';
        this.loading = false;
        this.error = '';
        this.reservationId = reservationId || '';
        this.listingTitle = details.listingTitle || '';
        this.streetAddress = details.streetAddress || '';
        this.locationLabel = details.locationLabel || '';
        this.dateRange = details.dateRange || '';
        this.imageUrl = details.imageUrl || '';

        Alpine.store('modals').open('review-modal');
    },

    close() {
        Alpine.store('modals').close('review-modal');
    },

    setRating(value) {
        this.rating = value;
        this.error = '';
    },

    async submit() {
        if (this.rating === 0) {
            this.error = 'Please select a rating.';
            return;
        }

        if (!this.review.trim()) {
            this.error = 'Please write a review.';
            return;
        }

        this.loading = true;
        this.error = '';

        try {
            const csrf = window.__csrfToken;
            const headers = {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            };
            if (csrf) {
                headers['X-CSRF-Token'] = csrf.value;
            }

            const response = await fetch('/actions/avari/review/submit', {
                method: 'POST',
                headers,
                body: JSON.stringify({
                    reservationId: this.reservationId,
                    rating: this.rating,
                    review: this.review,
                }),
            });

            const data = await response.json();

            if (data.success) {
                this.step = 'success';
            } else {
                this.error = data.error || 'Something went wrong. Please try again.';
            }
        } catch (e) {
            this.error = 'Something went wrong. Please try again.';
        } finally {
            this.loading = false;
        }
    },
});
